import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from '@calm-web/icons';
import { ButtonSizes } from '../Button';
import { StyledButton } from './styles';
const IconButton = (_a) => {
    var { backgroundColor = 'transparent', color = 'black' } = _a, props = __rest(_a, ["backgroundColor", "color"]);
    return (_jsx(StyledButton, Object.assign({ backgroundColor: backgroundColor, iconColor: color, size: ButtonSizes.Md }, props)));
};
export const CloseButton = (_a) => {
    var { Icon = Close } = _a, props = __rest(_a, ["Icon"]);
    return (_jsx(IconButton, Object.assign({ "aria-label": "close" }, props, { Icon: Icon })));
};
export default IconButton;
//# sourceMappingURL=index.js.map